import editorRule from "@/components/atoms/editorRule"
import { PortableText } from "next-sanity"

const Description = ({ description }) => {
  const base = 'content relative w-full text-bodyMobile lg:text-bodyDesktop font-chivoMono text-umber'
  return (
    <div className={base}>
      <PortableText value={description} components={editorRule()} />
    </div>
  )
}

export default Description
